function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRain = function SvgRain(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    xmlSpace: "preserve",
    viewBox: "0 0 100 100",
    y: 0,
    x: 0,
    width: "36px",
    height: "36px",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("g", {
    className: "ldl-scale",
    style: {
      transformOrigin: "50% 50%",
      transform: "scale(0.8)"
    }
  }, React.createElement("g", {
    className: "ldl-ani"
  }, React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.601852s infinite normal forwards running breath"
    }
  }, React.createElement("path", {
    fill: "#b5b5b5",
    clipRule: "evenodd",
    fillRule: "evenodd",
    d: "M73.6 32.8c.5-1.7.8-3.4.8-5.3 0-9.6-7.8-17.5-17.5-17.5-6.7 0-12.5 3.8-15.4 9.3-1.1-.3-2.3-.5-3.5-.5-6.4 0-11.6 5.2-11.6 11.6 0 .8.1 1.6.2 2.4-5.9.9-10.4 6-10.4 12.2 0 6.8 5.5 12.4 12.4 12.4h42.9c6.8 0 12.4-5.5 12.4-12.4-.1-6.2-4.5-11.3-10.3-12.2z",
    style: {
      fill: "rgb(181, 181, 181)"
    }
  }))), React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani"
  }, React.createElement("g", null, React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani"
  }, React.createElement("g", null, React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.648148s infinite normal forwards running breath"
    }
  }, React.createElement("path", {
    fill: "#77a4bd",
    d: "M28.3 66.8l1.5-3.8c.4-1-.1-2.1-1.1-2.5-1-.4-2.1.1-2.5 1.1l-1.5 3.8c-.4 1 .1 2.1 1.1 2.5.2.1.5.1.7.1.8 0 1.5-.5 1.8-1.2z",
    style: {
      fill: "rgb(119, 164, 189)"
    }
  })))))), React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani"
  }, React.createElement("g", null, React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.694444s infinite normal forwards running breath"
    }
  }, React.createElement("path", {
    fill: "#77a4bd",
    d: "M35.7 72.9l3.8-9.9c.4-1-.1-2.1-1.1-2.5-1-.4-2.1.1-2.5 1.1l-3.8 9.9c-.4 1 .1 2.1 1.1 2.5.2.1.5.1.7.1.8 0 1.6-.5 1.8-1.2z",
    style: {
      fill: "rgb(119, 164, 189)"
    }
  })))))), React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani"
  }, React.createElement("g", null, React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.740741s infinite normal forwards running breath"
    }
  }, React.createElement("path", {
    fill: "#77a4bd",
    d: "M43.2 79l6.1-16c.4-1-.1-2.1-1.1-2.5-1-.4-2.1.1-2.5 1.1l-6.1 16c-.4 1 .1 2.1 1.1 2.5.2.1.5.1.7.1.7 0 1.5-.5 1.8-1.2z",
    style: {
      fill: "rgb(119, 164, 189)"
    }
  })))))), React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani"
  }, React.createElement("g", null, React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.787037s infinite normal forwards running breath"
    }
  }, React.createElement("path", {
    fill: "#77a4bd",
    d: "M57 67.9l1.9-4.9c.4-1-.1-2.1-1.1-2.5-1-.4-2.1.1-2.5 1.1l-1.9 4.9c-.4 1 .1 2.1 1.1 2.5.2.1.5.1.7.1.8.1 1.6-.4 1.8-1.2z",
    style: {
      fill: "rgb(119, 164, 189)"
    }
  })))))), React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani"
  }, React.createElement("g", null, React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.833333s infinite normal forwards running breath"
    }
  }, React.createElement("path", {
    fill: "#77a4bd",
    d: "M61.8 81l6.5-18.1c.4-1-.2-2.1-1.2-2.5-1-.4-2.1.2-2.5 1.2l-6.5 18.1c-.4 1 .2 2.1 1.2 2.5.2.1.4.1.7.1.8 0 1.5-.5 1.8-1.3z",
    style: {
      fill: "rgb(119, 164, 189)"
    }
  })))))), React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani"
  }, React.createElement("g", null, React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.87963s infinite normal forwards running breath"
    }
  }, React.createElement("path", {
    fill: "#77a4bd",
    d: "M71.9 75.3l3.8-11.7c.3-1-.2-2.1-1.2-2.4-1-.3-2.1.2-2.4 1.2l-3.8 11.7c-.3 1 .2 2.1 1.2 2.4.2.1.4.1.6.1.8.1 1.5-.5 1.8-1.3z",
    style: {
      fill: "rgb(119, 164, 189)"
    }
  })))))), React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani"
  }, React.createElement("g", null, React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.925926s infinite normal forwards running breath"
    }
  }, React.createElement("path", {
    fill: "#77a4bd",
    d: "M20.1 88.8l5.7-15.4c.4-1-.1-2.1-1.1-2.5-1-.4-2.1.1-2.5 1.1l-5.7 15.4c-.4 1 .1 2.1 1.1 2.5.2.1.4.1.7.1.8 0 1.5-.5 1.8-1.2z",
    style: {
      fill: "rgb(119, 164, 189)"
    }
  })))))), React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani"
  }, React.createElement("g", null, React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.972222s infinite normal forwards running breath"
    }
  }, React.createElement("path", {
    fill: "#77a4bd",
    d: "M29.7 88.8L33 80c.4-1-.1-2.1-1.1-2.5-1-.4-2.1.1-2.5 1.1L26 87.4c-.4 1 .1 2.1 1.1 2.5.2.1.5.1.7.1.9 0 1.6-.5 1.9-1.2z",
    style: {
      fill: "rgb(119, 164, 189)"
    }
  })))))), React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani"
  }, React.createElement("g", null, React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -1.01852s infinite normal forwards running breath"
    }
  }, React.createElement("path", {
    fill: "#77a4bd",
    d: "M39.4 88.8l.9-2.4c.4-1-.1-2.1-1.1-2.5-1-.4-2.1.1-2.5 1.1l-.9 2.4c-.4 1 .1 2.1 1.1 2.5.2.1.5.1.7.1.8 0 1.6-.5 1.8-1.2z",
    style: {
      fill: "rgb(119, 164, 189)"
    }
  })))))), React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani"
  }, React.createElement("g", null, React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -1.06481s infinite normal forwards running breath"
    }
  }, React.createElement("path", {
    fill: "#77a4bd",
    d: "M49 88.8l5.3-13.5c.4-1-.1-2.1-1.1-2.5-1-.4-2.1.1-2.5 1.1l-5.3 13.5c-.4 1 .1 2.1 1.1 2.5.3.1.5.1.7.1.8 0 1.5-.5 1.8-1.2z",
    style: {
      fill: "rgb(119, 164, 189)"
    }
  })))))), React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani"
  }, React.createElement("g", null, React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -1.11111s infinite normal forwards running breath"
    }
  }, React.createElement("path", {
    fill: "#77a4bd",
    d: "M68.6 88.8l2.6-6.8c.4-1-.1-2.1-1.1-2.5-1-.4-2.1.1-2.5 1.1L65 87.4c-.4 1 .1 2.1 1.1 2.5.2.1.5.1.7.1.8 0 1.5-.5 1.8-1.2z",
    style: {
      fill: "rgb(119, 164, 189)"
    }
  }))))))))))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rain.a275b994.svg";
export { ForwardRef as ReactComponent };